<template>
  <div>
    <div class="card comments_block">
      <div class="card-header"><h6>Комментарии для менеджеров</h6></div>
      <div class="card-body">
        <div v-if="commentsForManager && commentsForManager.length" class="alert alert-success">
          <div v-for="comment in commentsForManager" class="border-bottom mb-2">
            <div v-html="comment.text"/>
            <p class="text-muted text-right">{{ comment.user_name }} {{
                printDate(comment.created_at, 'DD.MM.YYYY HH:mm', false, -1)
              }}</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <form @submit.prevent="saveComment()">
          <div class="input-group mb-3 mt-2">
            <input type="text" v-model="newManagerComment" placeholder="Комментарий к заявке" class="form-control"/>
            <div>
              <LoadingButton
                type="submit"
                title="Сохранить комментарий"
                className="btn btn-outline-success form-field"
                color="#4fc47f"
                :loading="saveCommentLoading"
                :onClick="() => {}"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card comments_block">
      <div class="card-header"><h6>Комментарии для курьеров</h6></div>
      <div class="card-body">
        <div v-if="commentsForRunner && commentsForRunner.length" class="alert alert-info">
          <div v-for="comment in commentsForRunner">
            <p>
              <template v-if="comment && +comment.comment_type === 2">
                <i class="icon-fa icon-fa-dropbox"/>
              </template>
              <template v-else><i class="icon-fa icon-fa-motorcycle"/></template>
              {{ comment.text }}
            </p>
            <p class="text-muted text-right">{{ comment.user_name }} {{ comment.created_at }}</p>
          </div>
        </div>
        <form @submit.prevent="saveComment('runner')">
          <!--          <div class="form-group mb-1">-->
          <!--            <input @change="updateCommentType" type="checkbox" id="type_1" v-model="commentTypes.packing.value">-->
          <!--            <label for="type_1">Комментарий также и для <strong>склада</strong></label>-->
          <!--          </div>-->
          <div class="input-group mb-3 mt-2">
            <input type="text" v-model="newRunnerComment" placeholder="Комментарий курьерам" class="form-control"/>
            <div>
              <LoadingButton
                title="Сохранить комментарий"
                type="submit"
                color="#4fc47f"
                className="btn btn-outline-success form-field"
                :loading="saveCommentLoading"
                :onClick="() => {}"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from '@/components/buttons/LoadingButton'
import moment from 'moment'

export default {
  components: {
    LoadingButton,
  },
  data() {
    return {
      commentType: 1,
      commentTypes: {
        packing: {
          type: 2,
          value: false
        }
      },
      saveCommentLoading: false,
      newManagerComment: null,
      newRunnerComment: null,
      commentsForRunner: [],
      commentsForManager: [],
      unSaved: false,
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  created() {
    this.commentsForManager = this.$editNewOrder && this.$editNewOrder.id && this.$editNewOrder.comment || []
    this.commentsForRunner = this.$editNewOrder && this.$editNewOrder.extra_options && this.$editNewOrder.extra_options.comments_for_runner || []
  },
  methods: {
    updateCommentType() {
      const selected = Object.values(this.commentTypes).find((t) => t.value);
      this.commentType = selected && selected.type || 1;
    },
    async getUnsavedComment() {
      if (this.newManagerComment) {
        await this.saveComment(null, false)
      }
      if (this.newRunnerComment) {
        await this.saveComment('runner', false)
      }
      this.$editNewOrder.comment = [...this.commentsForManager]
      this.$editNewOrder.extra_options.comments_for_runner = [...this.commentsForRunner]
      return {
        comment: [...this.commentsForManager],
        comments_for_runner: [...this.commentsForRunner]
      }
    },
    async saveComment(type = null, report = true) {
      if (this.saveCommentLoading) return
      const comment = type === 'runner' ? this.newRunnerComment : this.newManagerComment
      if (!comment) return
      this.saveCommentLoading = true
      let fieldSet = {comment: this.newManagerComment}
      if (type === 'runner') {
        fieldSet = {commentForRunner: this.newRunnerComment}
      }
      if (this.$editNewOrder && this.$editNewOrder.id) {
        const {data} = await api.post('/orders/updateOrderByField', {
          orderId: this.$editNewOrder.id,
          fields: fieldSet,
          commentType: this.commentType
        })
        if (data.success) {
          if (this.$editNewOrder && this.$editNewOrder.id && report) {
            toastr['success']('Сохранено')
          }
          this.updateComments(data && data.savedData || comment, type)
        } else {
          toastr['warning'](data.message || 'Ошибка сохранения комментария')
        }
      } else {
        this.unSaved = true
        this.updateComments({text: comment, comment_type: this.commentType || 1}, type)
      }
      this.saveCommentLoading = false
    },
    updateComments(comment, type) {
      const addData = {
        created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        text: comment.text,
        comment_type: comment.comment_type || 1,
        user_name: this.$currentUser.name,
        user_id: this.$currentUser.id,
        saved: !this.unSaved
      }
      if (type === 'runner') {
        this.commentsForRunner.push(addData)
        this.newRunnerComment = null
      } else {
        this.commentsForManager.push(addData)
        this.newManagerComment = null
      }
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 1px;
}

p.text-muted {
  font-size: 12px;
}

.card .card-header h6,
.card .card-header h5 {
  font-weight: 700;
}

.card .card-body {
  background-color: #f8f8f8 !important;
}
</style>
